<template>
  <div style="width: 100%">
    <div @click="onClick">
      <slot />
    </div>
    <Popup v-model="show" position="bottom" round>
      <picker
          :title="title"
          show-toolbar
          :columns="columns"
          value-key="label"
          @confirm="onConfirm"
          @cancel="close"
      />
    </Popup>
  </div>
</template>
<script>


import {defineComponent} from "vue";
import {Popup, Picker} from "vant";

export default defineComponent({
  components: {Popup, Picker},
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "选择"
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    onClick() {
      if (this.disable) return
      this.open()
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },
    onConfirm(_, index) {
      this.$emit("input", index)
      this.$emit("confirm", index)
      this.close()
    },
  }
})
</script>

<style scoped lang="scss">

</style>